module.exports = __webpack_public_path__ + "img/win.d0017cbd.png";